<style lang="scss">
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/mixins";
  @use "../../../assets/css/design-system/colors";

  .gap {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: utils.in_rem(12px);
    width: 100%;

    .content {
      overflow: hidden;
      flex-shrink: 1;
      display: flex;
      flex-direction: column;

      .label {
        display: flex;
        gap: utils.in_rem(12px);
        align-items: center;

        img {
          width: utils.in_rem(20px);
          height: utils.in_rem(20px);
        }

        .label-text {
          display: flex;
          align-items: center;
          flex-shrink: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          span {
            display: block;
            &:not(.required) {
              flex-shrink: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            &.required {
              flex-shrink: 0;
              @include colors.color(systemError_100);
            }
          }
        }
      }

      .description {
        overflow: hidden;
        @include colors.color(textGrey);
        text-overflow: ellipsis;
        @include mixins.body4();
      }
    }

    .status-tag {
      flex-shrink: 0;
    }
  }
</style>

<script>
  import Icon from "../../atoms/Icon.svelte";
  import StatusTag from "../../atoms/TagsAndChips/StatusTag.svelte";

  export let displayIcon = "";
  export let displaySrc = "";
  export let displayText = "";
  export let displayTextRequired = false;
  export let displayTextDescription = "";
  export let overflow = 0;

  const overflowProps = {
    kind: "information",
    size: "medium",
    contrast: "low",
  };
</script>

<!-- This component is used to display the selected items in the dropdown. -->
<div class="gap">
  <div class="content">
    <div class="label">
      {#if displayIcon}
        <div><Icon class={displayIcon} /></div>
      {:else if displaySrc}
        <div>
          <img src={displaySrc} alt="Icon" />
        </div>
      {/if}
      <div class="label-text">
        <span>{displayText}</span>
        {#if displayTextRequired}
          <span class="required">*</span>
        {/if}
      </div>
    </div>
    {#if displayTextDescription}
      <span class="description">{displayTextDescription}</span>
    {/if}
  </div>
  {#if overflow > 0}
    <div class="status-tag">
      <StatusTag {...overflowProps}>+{overflow}</StatusTag>
    </div>
  {/if}
</div>
